import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTableComponent } from './components/data-table/data-table.component';
import { LoginEmailInputComponent } from './components/login-email-input/email-input.component';
import { AccountLockedComponent } from './components/account-locked/account-locked.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PageToolbarComponent } from './components/page-toolbar/page-toolbar.component';
import { ChannelSidePanelComponent } from './components/channel-side-panel/channel-side-panel.component';
import { InitialsPipe } from './pipes/initials.pipe';

// New Create User shared components
import { FullNameInputComponent } from './components/full-name-input/full-name-input.component';
import { EmailInputComponent } from './components/email-input/email-input.component';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { SupervisoryLevelSelectorComponent } from './components/supervisory-level-selector/supervisory-level-selector.component';
import { RoleSelectComponent } from './components/role-select/role-select.component';
import { AccessTypeSelectorComponent } from './components/access-type-selector/access-type-selector.component';
import { SupervisorPickerComponent } from './components/supervisor-picker/supervisor-picker.component';
import { SupervisorPickerModalComponent } from './components/supervisor-picker/supervisor-picker-modal.component';
import { GeographicNodeSelectComponent } from './components/geographic-node-select/geographic-node-select.component';
import { ConfirmActionModalComponent } from './components/confirm-action-modal/confirm-action-modal.component';
import { GeographicTerritoryTreeComponent } from './components/geographic-territory-tree/geographic-territory-tree.component';
import { ToastComponent } from './components/toast/toast.component';
import { WizardStepperComponent } from './components/wizard-stepper/wizard-stepper.component';
import { SectionCardComponent } from './components/section-card/section-card.component';
import { SegmentedControlComponent } from './components/segmented-control/segmented-control.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { MultiSelectModalComponent } from './components/multi-select-modal/multi-select-modal.component';

@NgModule({
  declarations: [
    DataTableComponent,
    LoginEmailInputComponent,
    AccountLockedComponent,
    PageHeaderComponent,
    PageToolbarComponent,
    ChannelSidePanelComponent,
    InitialsPipe,
    FullNameInputComponent,
    EmailInputComponent,
    PhoneInputComponent,
    SupervisoryLevelSelectorComponent,
    RoleSelectComponent,
    AccessTypeSelectorComponent,
    SupervisorPickerComponent,
    SupervisorPickerModalComponent,
    GeographicNodeSelectComponent,
    ConfirmActionModalComponent,
    GeographicTerritoryTreeComponent,
    ToastComponent,
    WizardStepperComponent,
    SectionCardComponent,
    SegmentedControlComponent,
    ToggleSwitchComponent,
    MultiSelectModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DataTableComponent,
    LoginEmailInputComponent,
    AccountLockedComponent,
    PageHeaderComponent,
    PageToolbarComponent,
    ChannelSidePanelComponent,
    InitialsPipe,
    FullNameInputComponent,
    EmailInputComponent,
    PhoneInputComponent,
    SupervisoryLevelSelectorComponent,
    RoleSelectComponent,
    AccessTypeSelectorComponent,
    SupervisorPickerComponent,
    SupervisorPickerModalComponent,
    GeographicNodeSelectComponent,
    ConfirmActionModalComponent,
    GeographicTerritoryTreeComponent,
    ToastComponent,
    WizardStepperComponent,
    SectionCardComponent,
    SegmentedControlComponent,
    ToggleSwitchComponent,
    MultiSelectModalComponent
  ]
})
export class SharedModule { }

